import { BuildingId, UserId } from 'shared/models';

export const Actions = {
    ASSIGN_BUILDING_TO_USER_SUCCESS: 'ASSIGN_BUILDING_TO_USER_SUCCESS',

    UNASSIGN_BUILDING_FROM_USER_REQUEST: 'UNASSIGN_BUILDING_FROM_USER_REQUEST',
    UNASSIGN_BUILDING_FROM_USER_SUCCESS: 'UNASSIGN_BUILDING_FROM_USER_SUCCESS',
    UNASSIGN_BUILDING_FROM_USER_FAILURE: 'UNASSIGN_BUILDING_FROM_USER_FAILURE',
};

export const assignBuildingUserSuccess = (payload: { buildingId: BuildingId; userId: UserId }) => ({
    type: Actions.ASSIGN_BUILDING_TO_USER_SUCCESS,
    payload,
});

export const unassignBuildingUserRequest = (payload: { buildingId: string; userId: string }) => ({
    type: Actions.UNASSIGN_BUILDING_FROM_USER_REQUEST,
    payload,
});
export const unassignBuildingUserSuccess = (payload: { buildingId: string; userId: string }) => ({
    type: Actions.UNASSIGN_BUILDING_FROM_USER_SUCCESS,
    payload,
});
export const unassignBuildingUserFailure = (err: Error, meta: { buildingId: string; userId: string }) => ({
    type: Actions.UNASSIGN_BUILDING_FROM_USER_FAILURE,
    error: true,
    payload: err,
    meta,
});
